<template>
  <ColorCard :dataset="projectInfo" :disabled="true" class="project-item":defaultText="projectInfo.title">
    <template>
      <div class="btn-box">
        <div class="title-box">
          <ToolTip maxWidth="180px" :title="projectInfo.title">{{ projectInfo.title }}</ToolTip>
          <div class="status" v-if="projectInfo.status === -2">已冻结</div>
          <div class="status" v-if="projectInfo.is_archived === 1">已归档</div>
        </div>
      </div>
      <div class="boss-in" v-if="projectInfo.join_project_permission && projectInfo.status !== -2 && projectInfo.is_archived !== 1">
        <wf-button type="text" plain @click="toProject">以项目管理员的身份加入</wf-button>
      </div>
    </template>
  </ColorCard>
</template>

<script>
import ToolTip from '@/components/toolTip'
import ColorCard from '@/components/colorControl/card'
import api from '@/services/api/projectSetting/projectSetting'
export default {
  name: "ProjctItem",
  components: {
    ToolTip,
    ColorCard
  },
  props: {
    projectInfo: {
      type: Object
    },
  },
  data() {
    return {
    }
  },
  methods: {
    async toProject() {
      await this.$wfAlert('', '确定加入这个项目吗？', '加入该项目后自动成为项目管理员', '确定')
      await api.addProjectMember({ project_id: this.projectInfo.project_id })
      this.$message.success(`成功以管理员身份加入项目【${this.projectInfo.title}】`)
      this.$router.push({
        path: "/task",
        query: {
          projectId: this.projectInfo.project_id,
          isTabShow: true
        }
      })
    }
  }
}
</script>

<style lang="scss">
.project-item {
  position: relative;
  z-index: 1;
  &:hover {
    .btn-box .no-star-icon {
      visibility: visible;
    }
    .title-box .group-drag-box-icon {
      display: block;
    }
    .boss-in {
      display: flex;
    }
  }
  .boss-in {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.60);
    display: none;
    align-items: center;
    justify-content: center;
  }
  .btn-box {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .no-star-icon {
      visibility: hidden;
    }
  }
  .title-box {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
    i {
      font-size: 14px;
    }
    .group-drag-box-icon {
      margin-right: 8px;
      display: none;
    }
  }
  .star-icon {
    color: rgba(255, 190, 35, 0.8);
  }
  .no-star-icon {
    color: rgba(32,32,32,0.4);
  }
  .status {
    width: 54px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(32, 32, 32, 0.08);
    font-size: 14px;
    color: rgba(32, 32, 32, 0.60);
    flex-shrink: 0;
    border-radius: 4px;
  }
}
</style>
